import React, { useEffect, useState } from 'react'
import TopTitleBar from '../TopTitleBar'
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL, GET_HOLDER_DATA, USER_TOKEN } from '../../../../Utils/constant'
import API from '../../../../ApiConfig'
import Each from '../../../../components/Each';
import { Link } from "react-router-dom";
import cogoToast from 'cogo-toast-react-17-fix';
import { Delay } from '../../../../Utils/helper';
import Loader from '../../../../components/Loader';
import Icon from "react-icons-kit";
import { androidArrowBack } from 'react-icons-kit/ionicons/androidArrowBack'
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper';
import useRefreshToken from '../../../../Hooks/usegenerateToken';

import styles from '../Verifier/RequestVerifications/RequestDetails.module.css'

export default function VerifiedData() {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const navigate = useNavigate()
    const { holder_id } = useParams();
    const [formData, setformData] = useState();
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        getHolderData();
    }, [])
    async function getHolderData() {
        await Delay();
        API.get(`${GET_HOLDER_DATA}${holder_id}`)
            .then(res => {
                let data = res.data;
                if (data.success = 200) {
                    setformData(data);
                }
                else {
                    cogoToast.error("Something went wrong");
                }
            }).catch((err) => {
                // console.log(err);
                // console.log("An error occurred while fetching data");
            }
            )
    }
    return (
        <SlideUpWrapper direction='slide-left'>
            <>

                <h2 className={styles.header}>
                    <Icon icon={androidArrowBack} size={'1.2rem'} onClick={() => navigate('/dashboard/verifier-data')} style={{ cursor: 'pointer' }} />
                    Verification details
                </h2>
                <h3>Details</h3>
                {formData ?
                    <div className="credentials-table" style={{ width: "80%" }}>
                        <table border="3" style={{ borderCollapse: 'collapse', borderRadius: "5px" }}>
                            <tbody>
                                {formData.data.map((item, itemIndex) =>
                                    <>
                                        {item.authnumber && (
                                            <tr className='tableRow'>
                                                <th style={{ textAlign: "center", padding: "20px", width: "25%" }}>Authnumber</th>
                                                <td style={{ padding: "10px" }}>{item.authnumber}</td>
                                            </tr>
                                        )}
                                        {item.form_data.map((field, fieldIndex) => (
                                            <tr key={fieldIndex} className='tableRow'>
                                                <th style={{ textAlign: "center", padding: "20px", width: "25%" }}>{field.doc_field_name}</th>
                                                <td style={{ padding: "10px" }}>{field.consented_data?.includes("http") || field.consented_data?.includes("data:image") || field.consented_data.includes("localhost") ? (
                                                    <img
                                                        src={field.consented_data}
                                                        alt="Document"
                                                        style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                                        loading='lazy'
                                                        onError={(e) => (e.target.src = "/avatar@2x.png")} // Fallback image
                                                    />
                                                ) : (
                                                    field.consented_data // Render as text if not an image
                                                )}</td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div> :
                    [...Array(2)].map((_, index) => (
                        <div className="credentials-table" style={{ width: "80%" }}>
                            <table style={{ borderCollapse: 'collapse', borderRadius: "5px", textAlign: 'center' }}>
                                <tr className='credentials-header' key={index} style={{ textAlign: "center" }}>
                                    <td className="credentials-th flex-grow-1">
                                        <div className="shimmer" style={{ width: '7rem' }}></div>
                                    </td>
                                    <td className="credentials-th flex-grow-1">
                                        <div className="shimmer" style={{ width: '20rem' }}></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    ))}
            </>
        </SlideUpWrapper>
    )
}
